import { render, staticRenderFns } from "./ActiveInvocations.vue?vue&type=template&id=70ddb56f&"
import script from "./ActiveInvocations.vue?vue&type=script&lang=js&"
export * from "./ActiveInvocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports